module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-McKay-Web-640.57c598ee.jpg";